import React from "react";
import { Badge } from "reactstrap";

const FoodOrderStatusBadge = ({ status }) => {
  let color;
  let displayText;

  switch (status) {
    case "Completed":
      color = "success"; // Green
      displayText = "Completed";
      break;
    case "Pending":
      color = "warning"; // Yellow/Orange
      displayText = "Pending";
      break;
    case "Cancelled":
      color = "danger"; // Red
      displayText = "Cancelled";
      break;
    case "In Progress":
      color = "info"; // Blue
      displayText = "In Progress";
      break;
    case "Preparing":
      color = "primary"; // Blue
      displayText = "Preparing";
      break;
    case "Ready":
      color = "success"; // Green
      displayText = "Ready";
      break;
    default:
      color = "light"; // Light gray for unknown status
      displayText = status || "Unknown";
  }

  return (
    <Badge 
      color={color} 
      style={{ 
        padding: "6px 12px", 
        fontSize: "12px",
        fontWeight: "500",
        borderRadius: "20px"
      }}
    >
      {displayText}
    </Badge>
  );
};

export default FoodOrderStatusBadge;
